import {
  Building2,
  Briefcase,
  ArrowUpDown,
  HardHat,
  Scissors,
  Sprout,
  Truck,
  Flower2,
  Sparkles,
  Leaf,
  ArrowRight,
} from "lucide-react";
import { NETTOYAGE_SERVICES, ESPACES_VERTS_SERVICES } from "@/lib/content";

const ICONS = {
  Building2, Briefcase, ArrowUpDown, HardHat,
  Scissors, Sprout, Truck, Flower2,
};

function ServiceCard({ icon, title, desc, testId }) {
  const Icon = ICONS[icon];
  return (
    <article
      data-testid={testId}
      className="group relative flex flex-col rounded-2xl bg-white border border-[#E5E7E2] p-7 transition-all duration-300 hover:shadow-xl hover:-translate-y-1 hover:border-[#1A4331]/20"
    >
      <div className="grid place-items-center h-12 w-12 rounded-xl bg-[#F3F4F1] text-[#1A4331] group-hover:bg-[#1A4331] group-hover:text-white transition-colors duration-300">
        {Icon && <Icon className="h-5 w-5" />}
      </div>
      <h3 className="mt-5 font-display text-xl font-medium tracking-tight text-[#1E2320]">
        {title}
      </h3>
      <p className="mt-3 text-sm leading-relaxed text-[#5C635A]">{desc}</p>
      <a
        href="#contact"
        className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#1A4331] hover:text-[#123022] group/link"
      >
        Demander un devis
        <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover/link:translate-x-1" />
      </a>
    </article>
  );
}

function CategoryHeader({ kicker, title, desc, icon: Icon, color }) {
  return (
    <div className="flex flex-col gap-3 max-w-2xl">
      <div className="inline-flex items-center gap-2 text-xs uppercase tracking-widest" style={{ color }}>
        <Icon className="h-4 w-4" />
        {kicker}
      </div>
      <h3 className="font-display text-2xl sm:text-3xl font-medium tracking-tight text-[#1E2320]">
        {title}
      </h3>
      <p className="text-base text-[#5C635A] leading-relaxed">{desc}</p>
    </div>
  );
}

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#FDFCFB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Section heading */}
        <div className="max-w-3xl">
          <div className="text-xs uppercase tracking-widest font-semibold text-[#5C635A]">
            — Nos prestations
          </div>
          <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tighter text-[#1E2320] leading-tight">
            Deux savoir-faire,
            <br />
            <span className="text-[#1A4331]">un seul interlocuteur.</span>
          </h2>
          <p className="mt-6 text-base sm:text-lg text-[#5C635A] leading-relaxed max-w-2xl">
            Que ce soit pour vos locaux ou vos extérieurs, FBSERVICES vous accompagne
            avec une exigence constante : ponctualité, soin du détail et matériel professionnel.
          </p>
        </div>

        {/* Nettoyage block */}
        <div className="mt-20">
          <CategoryHeader
            kicker="01 · Nettoyage professionnel"
            title="Locaux propres, image impeccable."
            desc="Nous prenons en charge l'entretien régulier ou ponctuel de vos espaces — copropriétés, bureaux, cages d'escalier et chantiers livrés."
            icon={Sparkles}
            color="#1A4331"
          />
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {NETTOYAGE_SERVICES.map((s) => (
              <ServiceCard
                key={s.key}
                icon={s.icon}
                title={s.title}
                desc={s.desc}
                testId={`service-card-${s.key}`}
              />
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="my-20 h-px bg-gradient-to-r from-transparent via-[#E5E7E2] to-transparent" />

        {/* Espaces verts block */}
        <div>
          <CategoryHeader
            kicker="02 · Espaces verts"
            title="Jardins entretenus, extérieurs vivants."
            desc="De la taille de haie au débroussaillage réglementaire en passant par la plantation : nous prenons soin de vos extérieurs comme s'ils étaient les nôtres."
            icon={Leaf}
            color="#1A4331"
          />
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {ESPACES_VERTS_SERVICES.map((s) => (
              <ServiceCard
                key={s.key}
                icon={s.icon}
                title={s.title}
                desc={s.desc}
                testId={`service-card-${s.key}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
